// start:ng42.barrel
import './components';
import './controllers';
import './directives';
import './idp-external.service';
// end:ng42.barrel

